import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';
import {
  Complete,
  Loader,
  Selector,
} from './views';

const fiIds = ['mikomo'];

const buildOAuthUrl = (bankingConfig, redirectUrl, fiId, state) => {
  const {
    credentials: {
      baseUrl,
      clientId,
    },
  } = bankingConfig;
  const params = new URLSearchParams({
    connector: fiId,
    response_type: 'code',
    client_id: clientId,
    redirect_uri: redirectUrl,
    scope: 'openid email profile offline_access',
    state,
  });
  return `${baseUrl}/auth?${params.toString()}`;
};

export default function AkoyaContainer({
  resumeAuth: { fiId: initialFiId = false } = {},
  scoringRequest,
  scoringRequest: {
    trustStartPublicConfig: {
      banking: bankingConfig,
    } = {},
  },
  nextStep,
}) {
  const redirectUrl = [window.location.origin, 'auth'].join('/');
  const [loading, setLoading] = useState(false);
  const [fiId, setFiId] = useState(initialFiId);

  const startOauthProcess = (value) => {
    setLoading(true);
    const sessionId = uuid();
    localStorage.setItem(sessionId, JSON.stringify({
      providerId: 'akoya',
      redirectUrl,
      sessionId,
      fiId: value,
      scoringRequest,
    }));
    setFiId(value);
    window.location.href = buildOAuthUrl(bankingConfig, redirectUrl, value, sessionId);
  };

  if (loading) return (<Loader />);
  if (!fiId) {
    return (
      <Selector
        fiIds={fiIds}
        handleNextClick={startOauthProcess}
      />
    );
  }
  return (
    <Complete
      fiId={fiId}
      handleNextClick={nextStep}
    />
  );
}
